import React, { useEffect, useState } from 'react'
import { db } from '../..'
import { ref, onValue } from 'firebase/database'
import { useLocation } from 'react-router-dom'
import BottomMenu from './components/BottomMenu'

const TeamList = ({userData}) => {
    const location = useLocation();
    const { gameId, teamId } = location.state;
    const [teams, setTeams] = useState([]);
    const [members, setMembers] = useState([]);
    const roles = ["🏃‍♂️", "👹"];

    useEffect(() => {
        const teamsRef = ref(db, 'gameLogs/' + gameId + '/teams');
        const unsubscribeTeams = onValue(teamsRef, (snapshot) => {
            if(!snapshot.exists()) {
                setTeams([]);
                return;
            }

            // "今" はコールバックが呼ばれるたびに再計算する（呼び出しごとに新鮮な値にするため）
            const now = new Date();

            setTeams(snapshot.val().map((team, index) => {
                let cardStatus = null;

                // カードの使用中なら、カード名を格納
                if(team.usingCard) {
                    const limit = new Date(team.usingCard.limit);

                    if(now < limit) {
                        cardStatus = team.usingCard.name;
                    }
                }

                return ({
                    ...team,
                    id: index,
                    cardStatus: cardStatus
                })
            }));
        });

        const membersRef = ref(db, 'games/' + gameId + '/members');
        const unsubscribeMembers = onValue(membersRef, (snapshot) => {
            setMembers(snapshot.exists() ? Object.values(snapshot.val()) : []);
        });

        return () => {
            unsubscribeTeams();
            unsubscribeMembers();
        };
    }, [gameId]);

    return (
        <div className='max-w-xl mx-auto my-6'>
            <h1 className='text-2xl mb-4 mx-4 text-center'>すべてのチーム</h1>
            <p className='text-center text-gray-500 mb-6'>スコアランキング</p>

            <div className='m-5'>
                {teams.sort((a, b) => b.score - a.score).map((team, index) => (
                    <div key={index} className={'rounded-md px-4 py-2 mb-3 cursor-pointer hover:bg-gray-50 ' + (team.id === teamId ? 'bg-lime-50' : 'bg-white')}>
                        <div className='flex justify-between items-center'>
                            <h2 className='text-lg text-gray-700'>
                                <span className='font-normal text-lg me-2 tracking-widest'>{index + 1}位</span>
                                <i className='bi bi-people-fill me-2' style={{color: team.color}}></i>{team.name}
                            </h2>

                            <div>
                                <div className='flex gap-1 justify-end'>
                                    <p className='text-base text-gray-600'><i className='bi bi-coin text-yellow-500'></i> <span className='text-lime-600 font-medium text-lg'>{team.score}</span> pt</p>
                                    <p className='text-base text-gray-600'>{roles[team.role]}</p>
                                </div>

                                {
                                    team.cardStatus && <div className='mb-2 text-base rounded-md bg-yellow-100 text-yellow-700 py-1 px-2 m-1'>
                                        <i className='bi bi-collection me-2'></i>{team.cardStatus}
                                    </div>
                                }
                            </div>
                        </div>

                        <div className='my-0.5 ms-7'>
                            <i className='bi bi-person-fill text-gray-600/30 text-xl'></i>
                            {
                                members
                                    .filter((member) => Number(member.team) === team.id)
                                    .map((member, memberIndex) => (
                                        <span key={memberIndex} className='text-gray-500 rounded px-1 py-0.5 border mx-2 text-sm font-normal bg-white'>{member.name}</span>
                                    ))
                            }
                        </div>
                    </div>
                ))}
            </div>

            {/* 下部固定メニュー */}
            <BottomMenu gameId={gameId} teamId={teamId} />
        </div>
    )
}

export default TeamList